export default __webpack_public_path__ + "static/media/ios.81659939.svg";